/**
 * ChallengePage — thin wrapper that renders HomeworkPage in challenge mode.
 * This reuses 100% of the HomeworkPage UI (Circuit Composer, Hardware Layout,
 * Transpile, Submit buttons, etc.) with an API adapter layer that maps
 * challengeApi calls to homework-compatible shapes.
 */
import HomeworkPage from './HomeworkPage'

function ChallengePage() {
  return <HomeworkPage challengeMode />
}

export default ChallengePage
